module.exports = __webpack_public_path__ + "img/bg.3b5053aa.png";